<template>
  <div id="copywriting">
    <div class="pc">
        <toptab :topback="true"></toptab>
        <div class="copywritingbox">
            <div class="copywritingboxleft">
                <asidebar></asidebar>
            </div>
            <div class="copywritingboxright">
                <articlebox></articlebox>
            </div>
        </div>
    </div>
    <div class="mobile">
        <copywritingm></copywritingm>
    </div>
  </div>
</template>

<script>
import toptab from "@/components/toptab"
import asidebar from "@/components/asidebar"
import articlebox from "@/components/articlebox"
import copywritingm from "@/components/copywritingm"

export default {
    components: {
        toptab,
        asidebar,
        articlebox,
        copywritingm
    },
    data(){
        return{

        }
    },
    mounted(){
    }
}
</script>

<style lang="less">
    #copywriting{
        .copywritingbox{
            display: flex;
            .copywritingboxright{
                flex: 1 0 10%;
            }
        }
    }
</style>